<template>
  <a id="tag" :href="tag.link" :title="tag.name" target="_blank">
    {{ tag.name }}
  </a>
</template>

<script>
export default {
  name: 'Tag',
  props: ['tag'],
}
</script>

<style lang="scss" scoped>
#tag {
  color: #3b6152;
  text-align: left;
  font: normal normal 600 16px/19px Raleway;
  letter-spacing: 0px;
  color: #3B6152;
  opacity: 1;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #3B6152;
  border-radius: 18px;
  padding: 8px 16px;
  text-transform: capitalize;
}
</style>